import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-pop-up',
  templateUrl: './confirmation-pop-up.component.html',
  styleUrls: ['./confirmation-pop-up.component.scss']
})
export class ConfirmationPopUpComponent implements OnInit {

  @Input() header: string;
  @Input() confirmationStatement: string;
  @Input() message: string;
  @Input() showExit = false;
  @Input() showSave = false;
  @Input() showClose = false;
  @Input() showConfirm = false;
  @Input() showDelete = false;
  @Input() showDeactivate = false;
  @Input() showConfirmOk = false;
  @Input() showSaveChanges = false;
  @Input() showClearChanges = false;
  @Input() textTransformNone = false;

  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onExit = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Output() onConfirm = new EventEmitter();
  @Output() onDeactivate = new EventEmitter();
  @Output() onConfirmOk = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public emitConfirm(): void {
    this.onConfirm.emit();
  }

  public emitClose(): void {
    this.onClose.emit();
  }

  public emitDelete(): void {
    this.onDelete.emit();
  }

  public emitExit(): void {
    this.onExit.emit();
  }

  public emitSave(): void {
    this.onSave.emit();
  }

  public emitDeactivate(): void {
    this.onDeactivate.emit();
  }

  public emitOk(): void {
    this.onConfirmOk.emit();
  }

}
